module.exports = __webpack_public_path__ + "80d5917e88d56e7957e79dd92c3fa372.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/harvard_university_3_2023_chart.png
// module id = 1686
// module chunks = 0